export const educationData = [
    {
        id: 1,
        institution: 'Narayani Public College',
        address: "Bharatpur, Chitwan, Nepal",
        course: 'Higher Secondary Education (Computer-Science)',
        startYear: '2018',
        endYear: '2020'
    },
    {
        id: 2,
        institution: 'Balkumari College',
        course: 'Bachelor of Information & Managment',
        address: "Chitwan, Nepal",
        startYear: '2021',
        endYear: 'PRESENT'
    },
]